<template>
  <el-popover
    placement="top-start"
    width="280"
    trigger="hover"
  >
    <div>
      <el-row :gutter="10">
        <el-col :span="24">服务人员:{{scope.row[tableData.waiterNameBind]}}</el-col>
        <el-col :span="24">销售人员:{{scope.row[tableData.salesNameBind]}}</el-col>

      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">订单进度</el-col>
        <el-col :span="18">
          <el-progress
            :text-inside="true"
            :stroke-width="18"
            :percentage="getPercent"
          ></el-progress>
        </el-col>
      </el-row>
    </div>
    <span slot="reference">{{scope.row[tableData.bind]}}</span>
  </el-popover>
</template>

<script>
import { taskStatus } from '@/common/dictionary'
import { formatElementPerc } from '@/common/util'
export default {
  name: 'taskStatus',
  props: {
    tableData: Object,
    scope: Object
  },
  computed: {
    getPercent() {
      if (this.scope.row.count === 0) return 0
      return formatElementPerc(
        (this.scope.row.orderFinishCount / this.scope.row.orderCount) * 100
      )
    }
  },
  mounted() {}
}
</script>

<style scoped>
</style>
